<template>
  <v-app>
    <!-- <v-app-bar app color="primary" dark elevation="4">
      <v-toolbar-title class="headline">
        <v-icon left>mdi-cash-multiple</v-icon>
        Sistema de Asignación de Cobranza
      </v-toolbar-title>
      <v-spacer></v-spacer> -->
    <!-- <v-btn color="white" outlined @click="exportarExcel">
        <v-icon left>mdi-microsoft-excel</v-icon>
        Exportar Excel
      </v-btn>
      <v-btn icon @click="mostrarGraficos = !mostrarGraficos" class="ml-2">
        <v-icon>{{ mostrarGraficos ? 'mdi-chart-box-outline' : 'mdi-chart-box' }}</v-icon>
      </v-btn> -->
    <!-- </v-app-bar> -->

    <v-main class="pa-4 elevation-1 mb-4">
      <v-container fluid>
        <v-card class="mb-4">
          <v-toolbar class="primary white--text d-flex justify-center align-center">
            <v-icon color="white" left>mdi-cash-multiple</v-icon>
            ASIGNACION DE COBRANZA POR SEDE
          </v-toolbar>

        </v-card>
        <v-card class="pa-4 elevation-1 mb-4">
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="menuFechaInicio" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateInicio" label="Seleccione la fecha Inicio:" prepend-icon="mdi-calendar"
                    readonly outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateInicio" @input="menuFechaInicio = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="date" label="Seleccione la fecha:" prepend-icon="mdi-calendar" readonly
                    outlined dense hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="2" md="3">
              <v-btn color="primary" :disabled="loading" :loading="loading" @click="cargasDatosV2()">
                Calcular
              </v-btn>
            </v-col>
          </v-row>
        </v-card>


        <div v-if="filtros.programa">
          <v-alert dense outlined type="info">
            <small class="red--text">
              Tomar en cuenta la fecha de inicio del programa para poder ver correctamente los datos
            </small>
            <p class="mb-0"><b>Fecha inicio del programa:</b> {{ filtros.programa.fecha_inicio }}</p>
            <p class="mb-0"><b>Fecha de finalizacion:</b> {{ filtros.programa.fecha_fin }}</p>
          </v-alert>
        </div>
        <!-- Reemplaza las tarjetas de estadísticas existentes con: -->

        <v-row class="mb-4">
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="indigo darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_programas }}</div>
                <div class="caption">Programas</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="blue darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_registros }}</div>
                <div class="caption">Total Registros</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="purple darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_estudiantes_unicos }}</div>
                <div class="caption">Estudiantes</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="green darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_vigentes }}</div>
                <div class="caption">Vigentes</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="orange darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_retrasados }}</div>
                <div class="caption">Retrasados</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="red darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_por_recuperar }}</div>
                <div class="caption">Por Recuperar</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="#5E35B1 darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_fechas_cambiadas }}</div>
                <div class="caption">Fechas Cambiadas</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="lime darken-4" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_reincorporados }}</div>
                <div class="caption">Cuotas Reincorporados</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" class="cols-custom-7">
            <v-card color="lime darken-3" dark>
              <v-card-text class="text-center">
                <div class="text-h4 font-weight-bold">{{ estadisticasGenerales.total_reincorporados_persona }}</div>
                <div class="caption">Estudiantes Reincorporados</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Totales monetarios -->
        <v-row dense>
          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">
              <v-card color="teal darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text>
                  <div class="text-h4 font-weight-bold">
                    {{ formatMonto(estadisticasGenerales.saldo_total) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Total Asignación
                  </div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_saldo_cobranza) }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_saldo_marketing) }}</div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>

          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">
              <v-card color="orange darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticasGenerales.total_descuento_fecha_consulta) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Total Disminucion</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_descuento_cobranza) }}
                      </div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_descuento_marketing) }}
                      </div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">
              <v-card color="#5E35B1 darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticasGenerales.total_monto_fechas_cambiadas) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Total Cambios Fechas</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_monto_fechas_cambiadas_cobranza)
                        }}
                      </div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_monto_fechas_cambiadas_marketing)
                        }}
                      </div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">
              <v-card color="lime darken-4" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticasGenerales.total_monto_reincorporados) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Total Reincorporados</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_monto_reincorporados_cobranza)
                        }}
                      </div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_monto_reincorporados_marketing)
                        }}
                      </div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">

              <v-card color="teal darken-4" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticasGenerales.total_pagado_fecha_consulta) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Monto Cobrado</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_pagado_cobranza) }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticasGenerales.total_pagado_marketing) }}
                      </div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>

          <v-col cols="6" sm="4" md="2">
            <v-hover v-slot="{ hover }">

              <v-card color="red darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticasGenerales.saldo_total -
                      estadisticasGenerales.total_descuento_fecha_consulta -
                      estadisticasGenerales.total_monto_fechas_cambiadas -
                      estadisticasGenerales.total_pagado_fecha_consulta) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Saldo a Cobrar</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_saldo_cobranza -
                          estadisticasGenerales.total_descuento_cobranza -
                          estadisticasGenerales.total_monto_fechas_cambiadas_cobranza -
                          estadisticasGenerales.total_pagado_cobranza)
                      }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_saldo_marketing -
                          estadisticasGenerales.total_descuento_marketing -
                          estadisticasGenerales.total_monto_fechas_cambiadas_marketing -
                          estadisticasGenerales.total_pagado_marketing)
                      }}</div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>
        </v-row>




        <v-row dense class="mt-4">
          <v-col cols="12" md="8">
            <v-alert outlined color="primary" border="left" class="py-2 mb-0">
              <div class="font-weight-bold">
                Totales ajustados
              </div>
              <div class="text-caption">
                Considera reincorporaciones, cambios de fechas y descuentos aplicados
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="4">
            <v-hover v-slot="{ hover }">
              <v-card color="indigo darken-3" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="py-3">
                  <div class="text-subtitle-2 text-uppercase mb-1" style="letter-spacing: 1px;">
                    <v-icon left small color="white">mdi-percent</v-icon>% Cobro de Sede
                  </div>
                  <v-row no-gutters align="center" justify="space-around">
                    <v-col cols="6">
                      <div class="text-h5 font-weight-bold">
                        {{ porcentajeCobroSede.porc_pagado.toFixed(1) }}%
                      </div>
                      <div class="text-caption">Pagado / Asignado</div>
                    </v-col>
                    <v-col cols="6">
                      <div class="text-h5 font-weight-bold">
                        {{ porcentajeCobroSede.porc_recuperado.toFixed(1) }}%
                      </div>
                      <div class="text-caption">Recuperado total</div>
                    </v-col>
                  </v-row>
                  <v-progress-linear :value="porcentajeCobroSede.porc_recuperado" color="light-green accent-3"
                    height="6" rounded class="mt-2"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>


        <!-- Total Asignacion -->
        <v-row class="mb-4" dense>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-card color="teal darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">
                    {{
                      formatMonto(estadisticasGenerales.saldo_total +
                        estadisticasGenerales.total_monto_reincorporados -
                        estadisticasGenerales.total_descuento_fecha_consulta -
                        estadisticasGenerales.total_monto_fechas_cambiadas) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Total Asignacion </div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_saldo_cobranza +
                          estadisticasGenerales.total_monto_reincorporados_cobranza -
                          estadisticasGenerales.total_descuento_cobranza -
                          estadisticasGenerales.total_monto_fechas_cambiadas_cobranza)
                      }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticasGenerales.total_saldo_marketing +
                          estadisticasGenerales.total_monto_reincorporados_marketing -
                          estadisticasGenerales.total_descuento_marketing -
                          estadisticasGenerales.total_monto_fechas_cambiadas_marketing)
                      }}</div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">

              <v-card color="teal darken-4" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.pagadoTotal) }}</div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Monto Cobrado</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalCobranza) }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalMarketing) }}</div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>

          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">

              <v-card color="red darken-2" :elevation="hover ? 12 : 2" dark
                class="rounded-xl transition-ease text-center">
                <v-card-text class="text-center">
                  <div class="text-h4 font-weight-bold">{{
                    formatMonto(estadisticas.saldoTotal - estadisticas.descuentoTotal -
                      estadisticas.total_monto_fechas_cambiadas - estadisticas.pagadoTotal) }}
                  </div>
                  <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                    Saldo a Cobrar</div>
                  <v-divider dark class="mb-3"></v-divider>
                  <v-row justify="space-around" align="center" no-gutters>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticas.saldoTotalCobranza - estadisticas.descuentoTotalCobranza -
                          estadisticas.total_monto_fechas_cambiadas_cobranza -
                          estadisticas.pagadoTotalCobranza)
                      }}</div>
                      <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-cash</v-icon> Cobranza
                      </v-chip>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-weight-bold">{{
                        formatMonto(estadisticas.saldoTotalMarketing - estadisticas.descuentoTotalMarketing -
                          estadisticas.total_monto_fechas_cambiadas_marketing -
                          estadisticas.pagadoTotalMarketing)
                      }}</div>
                      <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                        <v-icon left small>mdi-account-group</v-icon> Marketing
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- Segunda fila de totales monetarios -->
        <!-- <v-row class="mb-4">
          <v-col cols="12" sm="2">
            <v-card color="teal darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{ formatMonto(estadisticasGenerales.monto_total) }}</div>
                <div class="caption">Monto Total</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="2">
            <v-card color="success darken-1" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{ formatMonto(estadisticasGenerales.pagado_total) }}</div>
                <div class="caption">Pagado Total Fecha Inicio Mes</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="2">
            <v-card color="success darken-1" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{
                  formatMonto(estadisticasGenerales.total_pagado_fecha_consulta) }}
                </div>
                <div class="caption">Pagado Total Fecha Consulta</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="2">
            <v-card color="success darken-1" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{
                  formatMonto(estadisticasGenerales.total_descuento_fecha_consulta)
                }}</div>
                <div class="caption">Descuento Total Fecha Consulta</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="2">
            <v-card color="pink darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{ formatMonto(estadisticasGenerales.saldo_total) }}</div>
                <div class="caption"> Asignacion</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="2">
            <v-card color="pink darken-2" dark>
              <v-card-text class="text-center">
                <div class="text-h5 font-weight-bold">Bs. {{
                  formatMonto(estadisticasGenerales.saldo_total - estadisticasGenerales.total_pagado_fecha_consulta -
                    estadisticasGenerales.total_descuento_fecha_consulta)
                }}</div>
                <div class="caption">Saldo Asignacion</div>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row> -->




        <!-- Desempeño por Cobrador -->
        <v-expansion-panels class="mb-4">
          <v-expansion-panel>
            <v-expansion-panel-header class="white--text" style="background-color: #6a1b9a;">
              <span class="font-weight-bold">
                <v-icon color="white" left>mdi-account-cash</v-icon>
                Desempeño por Cobrador
                <v-chip color="white" outlined small class="ml-2 font-weight-medium">
                  {{ desempenoPorCobrador.length }} cobradores
                </v-chip>
              </span>
              <template v-slot:actions>
                <v-icon color="white">mdi-chevron-down</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-data-table :headers="headersDesempenoCobrador" :items="desempenoPorCobrador"
                :items-per-page="10" item-key="cobrador" dense class="elevation-0">
                <template v-slot:item.cobrador="{ item }">
                  <v-avatar size="28" color="deep-purple" class="mr-2">
                    <span class="white--text text-caption">{{ getIniciales(item.cobrador) }}</span>
                  </v-avatar>
                  <span class="font-weight-medium">{{ item.cobrador }}</span>
                </template>
                <template v-slot:item.asignado="{ item }">Bs {{ formatMonto(item.asignado) }}</template>
                <template v-slot:item.pagado="{ item }">Bs {{ formatMonto(item.pagado) }}</template>
                <template v-slot:item.descuento="{ item }">Bs {{ formatMonto(item.descuento) }}</template>
                <template v-slot:item.cambios_sin_pago="{ item }">Bs {{ formatMonto(item.cambios_sin_pago) }}</template>
                <template v-slot:item.saldo_pendiente="{ item }">Bs {{ formatMonto(item.saldo_pendiente) }}</template>
                <template v-slot:item.porc_pagado="{ item }">
                  <v-chip small :color="item.porc_pagado >= 70 ? 'green' : item.porc_pagado >= 40 ? 'orange' : 'red'"
                    dark>{{ item.porc_pagado.toFixed(1) }}%</v-chip>
                </template>
                <template v-slot:item.porc_recuperado="{ item }">
                  <v-chip small
                    :color="item.porc_recuperado >= 70 ? 'green' : item.porc_recuperado >= 40 ? 'orange' : 'red'"
                    dark>{{ item.porc_recuperado.toFixed(1) }}%</v-chip>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="mb-4" elevation="4">
          <v-card-title class="white--text" style="background-color: #1976d2;">
            <v-icon color="white" left>mdi-school</v-icon>
            <span class="font-weight-bold">Resumen por Programa</span>


            <v-spacer></v-spacer>
            <v-btn color="success" :loading="exportando" :disabled="exportando" @click="exportarAExcel">
              <v-icon left>mdi-file-excel</v-icon>
            </v-btn>

            <v-chip color="white" outlined small class="font-weight-medium">
              {{ datosAgrupadosPorPrograma.length }} programas
            </v-chip>
          </v-card-title>


          <v-data-table :headers="headersPrograma" :items="datosAgrupadosPorPrograma" :items-per-page="10"
            :search="buscarPrograma" item-key="idprograma" show-expand class="elevation-1">
            <template v-slot:top>
              <v-row>
                <v-text-field v-model="buscarPrograma" append-icon="mdi-magnify" label="Busqueda..." single-line
                  hide-details class="mx-4 pa-4"></v-text-field>
              </v-row>


            </template>

            <!-- Asignacion -->
            <template v-slot:item.total_saldo_fecha="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_fecha) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_saldo_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_cobranza) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_saldo_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_marketing) }}</strong>
              </div>
            </template>

            <!-- Reincorporados -->

            <template v-slot:item.total_monto_reincorporados="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_reincorporados) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_monto_reincorporados_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_reincorporados_cobranza) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_monto_reincorporados_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_reincorporados_marketing) }}</strong>
              </div>
            </template>

            <!-- Disminuciones -->
            <template v-slot:item.total_descuento_fecha_consulta="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_descuento_fecha_consulta) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_descuento_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_descuento_marketing) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_descuento_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_descuento_cobranza) }}</strong>
              </div>
            </template>


            <!-- Cambios Fechas -->
            <template v-slot:item.total_monto_fechas_cambiadas="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_fechas_cambiadas) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_monto_fechas_cambiadas_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_fechas_cambiadas_marketing) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_monto_fechas_cambiadas_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_monto_fechas_cambiadas_cobranza) }}</strong>
              </div>
            </template>


            <!-- Pagado -->
            <template v-slot:item.total_pagado_fecha_consulta="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_pagado_fecha_consulta) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_pagado_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_pagado_cobranza) }}</strong>
              </div>
            </template>
            <template v-slot:item.total_pagado_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_pagado_marketing) }}</strong>
              </div>
            </template>


            <!-- Saldo -->
            <template v-slot:item.saldo="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_fecha - item.total_descuento_fecha_consulta -
                  item.total_monto_fechas_cambiadas -
                  item.total_pagado_fecha_consulta) }}</strong>
              </div>
            </template>
            <template v-slot:item.saldo_cobranza="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_cobranza - item.total_descuento_cobranza -
                  item.total_monto_fechas_cambiadas_cobranza -
                  item.total_pagado_cobranza) }}</strong>
              </div>
            </template>

            <template v-slot:item.saldo_marketing="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_saldo_marketing - item.total_descuento_marketing -
                  item.total_monto_fechas_cambiadas_marketing -
                  item.total_pagado_marketing) }}</strong>
              </div>
            </template>
            <!-- Slot para la fila expandida -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-container fluid class="pa-4 grey lighten-4">
                  <!-- Aquí reutilizamos EXACTAMENTE tu diseño de 3 columnas -->
                  <v-row dense>
                    <!-- Info Programa -->
                    <v-col cols="12" md="4">
                      <v-card outlined class="rounded-lg">
                        <v-card-title class="subtitle-2 grey lighten-3">
                          <v-icon small left color="indigo">mdi-information-outline</v-icon>
                          Información del Programa
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-item v-for="(valor, key) in {
                            Modalidad: item.modalidad,
                            Categoría: item.categoria,
                            Área: item.area,
                            'Fecha Inicio': formatFecha(item.fecha_inicio),
                            'Fecha Fin': formatFecha(item.fecha_fin)
                          }" :key="key">
                            <v-list-item-content>
                              <v-list-item-subtitle>{{ key }}</v-list-item-subtitle>
                              <v-list-item-title>{{ valor }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                    <!-- Estados -->
                    <v-col cols="12" md="4">
                      <v-card outlined class="rounded-lg">
                        <v-card-title class="subtitle-2 grey lighten-3">
                          <v-icon small left color="teal">mdi-chart-pie</v-icon>
                          Estados de Cobranza
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-subtitle>Total Registros</v-list-item-subtitle>
                            <v-chip small color="blue" dark>{{ item.total_registros }}</v-chip>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-subtitle>Vigentes</v-list-item-subtitle>
                            <v-chip small color="green" dark>{{ item.total_vigentes }}</v-chip>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-subtitle>Retrasados</v-list-item-subtitle>
                            <v-chip small color="orange" dark>{{ item.total_retrasados }}</v-chip>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-subtitle>Por Recuperar</v-list-item-subtitle>
                            <v-chip small color="red" dark>{{ item.total_por_recuperar }}</v-chip>
                          </v-list-item>
                          <v-divider class="my-2"></v-divider>
                          <v-list-item>
                            <v-list-item-subtitle>Estudiantes Únicos</v-list-item-subtitle>
                            <v-chip small color="deep-purple" dark>{{ item.total_estudiantes }}</v-chip>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>

                    <!-- Totales -->
                    <v-col cols="12" md="4">
                      <v-card outlined class="rounded-lg">
                        <v-card-title class="subtitle-2 grey lighten-3">
                          <v-icon small left color="amber darken-1">mdi-currency-usd</v-icon>
                          Totales Monetarios
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-subtitle>Asignado</v-list-item-subtitle>
                            <v-list-item-title class="text-h6">
                              Bs. {{ formatMonto(item.total_saldo_fecha) }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-subtitle>Descuentos</v-list-item-subtitle>
                            <v-list-item-title class="orange--text font-weight-bold">
                              Bs. {{ formatMonto(item.total_descuento_fecha_consulta) }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-subtitle>Pagado</v-list-item-subtitle>
                            <v-list-item-title class="success--text font-weight-bold">
                              Bs. {{ formatMonto(item.total_pagado_fecha_consulta) }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-subtitle class="font-weight-bold">Saldo</v-list-item-subtitle>
                            <v-list-item-title class="text-h5 red--text font-weight-bold">
                              Bs. {{ formatMonto(item.total_saldo_fecha - item.total_descuento_fecha_consulta -
                                item.total_pagado_fecha_consulta) }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Botón -->
                  <v-row>
                    <v-col cols="12" class="text-center pt-4">
                      <v-btn color="primary" outlined @click="verDetallePrograma(item)">
                        <v-icon left>mdi-table-eye</v-icon>
                        Ver Detalle Completo ({{ item.total_registros }} registros)
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-container>
              </td>
            </template>

            <!-- Puedes usar slots para formatear las celdas de la tabla principal también -->
            <!-- <template v-slot:item.total_saldo_fecha="{ item }">
              <v-chip small color="green" dark>
                Bs. {{ formatMonto(item.total_saldo_fecha) }}
              </v-chip>
            </template> -->

          </v-data-table>
        </v-card>

        <!-- Tarjetas de Estadísticas -->
        <v-card class="mb-4" elevation="3">
          <v-card-title class="white--text mb-4" style="background-color: #1976d2;">
            <v-icon color="white" left>mdi-chart-bar</v-icon>
            <span class="font-weight-bold">{{ tituloEstadisticasProgramas }}</span>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-4" dense>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="blue darken-2" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.total }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Total</div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="green darken-2" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.vigentes }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Vigentes</div>
                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="red darken-2" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.retrasados }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Retrasados</div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="orange darken-2" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.porRecuperar }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Por Recuperar</div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="#5E35B1 darken-2" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.total_fechas_cambiadas }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Fechas Cambiadas</div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="lime darken-4" dark :elevation="hover ? 12 : 2"
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ estadisticas.total_reincorporados }}</div>
                      <div class="text-subtitle-2 text-uppercase" style="letter-spacing: 1px;">Reincorporados</div>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="teal darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text>
                      <div class="text-h4 font-weight-bold">
                        {{ formatMonto(estadisticas.saldoTotal) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Total Asignación
                      </div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.saldoTotalCobranza) }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.saldoTotalMarketing) }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>

              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="orange darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.descuentoTotal) }}</div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Total Disminucion</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.descuentoTotalCobranza) }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.descuentoTotalMarketing) }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>

              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="#5E35B1 darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.total_monto_fechas_cambiadas) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Total Cambios Fechas</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.total_monto_fechas_cambiadas_cobranza) }}
                          </div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.total_monto_fechas_cambiadas_marketing) }}
                          </div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">
                  <v-card color="lime darken-4" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.total_monto_reincorporados) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Total Reincorporados</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.total_monto_reincorporados_cobranza) }}
                          </div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.total_monto_reincorporados_marketing) }}
                          </div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>
              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">

                  <v-card color="teal darken-4" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.pagadoTotal) }}</div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Monto Cobrado</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalCobranza) }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalMarketing) }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>

              <v-col cols="6" sm="4" md="2">
                <v-hover v-slot="{ hover }">

                  <v-card color="red darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{
                        formatMonto(estadisticas.saldoTotal - estadisticas.descuentoTotal -
                          estadisticas.total_monto_fechas_cambiadas - estadisticas.pagadoTotal) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Saldo a Cobrar</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalCobranza - estadisticas.descuentoTotalCobranza -
                              estadisticas.total_monto_fechas_cambiadas_cobranza -
                              estadisticas.pagadoTotalCobranza)
                          }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalMarketing - estadisticas.descuentoTotalMarketing -
                              estadisticas.total_monto_fechas_cambiadas_marketing -
                              estadisticas.pagadoTotalMarketing)
                          }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            <v-row dense class="mt-4">
              <v-col cols="12">
                <v-alert outlined color="primary" border="left" class="py-2">
                  <div class="font-weight-bold">
                    Totales ajustados
                  </div>
                  <div class="text-caption">
                    Considera reincorporaciones, cambios de fechas y descuentos aplicados
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <!-- Total Asignacion -->
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot="{ hover }">

                  <v-card color="teal darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{
                        formatMonto(estadisticas.saldoTotal + estadisticas.total_monto_reincorporados -
                          estadisticas.descuentoTotal -
                          estadisticas.total_monto_fechas_cambiadas) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Total Asignacion </div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalCobranza +
                              estadisticas.total_monto_reincorporados_cobranza -
                              estadisticas.descuentoTotalCobranza -
                              estadisticas.total_monto_fechas_cambiadas_cobranza)
                          }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalMarketing +
                              estadisticas.total_monto_reincorporados_cobranza -
                              estadisticas.descuentoTotalMarketing -
                              estadisticas.total_monto_fechas_cambiadas_marketing
                            )
                          }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot="{ hover }">

                  <v-card color="teal darken-4" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{ formatMonto(estadisticas.pagadoTotal) }}</div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Monto Cobrado</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalCobranza) }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{ formatMonto(estadisticas.pagadoTotalMarketing) }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>

              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-hover v-slot="{ hover }">

                  <v-card color="red darken-2" :elevation="hover ? 12 : 2" dark
                    class="rounded-xl transition-ease text-center">
                    <v-card-text class="text-center">
                      <div class="text-h4 font-weight-bold">{{
                        formatMonto(estadisticas.saldoTotal - estadisticas.descuentoTotal -
                          estadisticas.total_monto_fechas_cambiadas - estadisticas.pagadoTotal) }}
                      </div>
                      <div class="text-subtitle-2 text-uppercase mb-3" style="letter-spacing: 1px;">
                        Saldo a Cobrar</div>
                      <v-divider dark class="mb-3"></v-divider>
                      <v-row justify="space-around" align="center" no-gutters>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalCobranza - estadisticas.descuentoTotalCobranza -
                              estadisticas.total_monto_fechas_cambiadas_cobranza -
                              estadisticas.pagadoTotalCobranza)
                          }}</div>
                          <v-chip color="red lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-cash</v-icon> Cobranza
                          </v-chip>
                        </v-col>
                        <v-col cols="6">
                          <div class="font-weight-bold">{{
                            formatMonto(estadisticas.saldoTotalMarketing - estadisticas.descuentoTotalMarketing -
                              estadisticas.total_monto_fechas_cambiadas_marketing -
                              estadisticas.pagadoTotalMarketing)
                          }}</div>
                          <v-chip color="green lighten-1" small text-color="white" class="mt-1">
                            <v-icon left small>mdi-account-group</v-icon> Marketing
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Filtros y Búsqueda -->
        <v-card class="mb-4" elevation="3">
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" md="4">
                <v-text-field v-model="busqueda" label="Buscar estudiante..." prepend-inner-icon="mdi-magnify" outlined
                  dense hide-details clearable></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="filtroAsignacion" :items="opcinesAsignaciones" label="Tipo de Asignación" outlined
                  dense hide-details></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="filtroEstado" :items="opcionesEstado" label="Estado de Cobranza" outlined dense
                  hide-details></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="filtroTipoPlan" :items="opcionesTipoPlan" label="Tipo de Plan" outlined dense
                  hide-details></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select v-model="filtroConceptos" :items="datosConceptos" item-text="concepto"
                  item-value="concepto_id" label="Conceptos" multiple chips clearable outlined dense
                  hide-details></v-select>
              </v-col>

              <v-col cols="12" md="2">
                <v-btn color="error" outlined block @click="limpiarFiltros">
                  <v-icon left>mdi-filter-remove</v-icon>
                  Limpiar
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col>
                <v-chip-group v-model="chipSeleccionado" active-class="primary--text">
                  <v-chip>Todos</v-chip>
                  <v-chip color="green" outlined>Vigentes</v-chip>
                  <v-chip color="red" outlined>Retrasados</v-chip>
                  <v-chip color="orange" outlined>Por Recuperar</v-chip>
                </v-chip-group>
              </v-col>
            </v-row>

            <v-expansion-panels v-model="panelFiltrosAvanzados" flat class="mt-2">
              <v-expansion-panel>
                <v-expansion-panel-header class="text-subtitle-2">
                  <span><v-icon left small>mdi-tune</v-icon>Filtros avanzados</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-select v-model="filtroModalidad" :items="opcionesModalidad" label="Modalidad" outlined dense
                        hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select v-model="filtroCategoria" :items="opcionesCategoria" label="Categoría" outlined dense
                        hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select v-model="filtroArea" :items="opcionesArea" label="Área" outlined dense
                        hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select v-model="filtroPlanModificado" :items="opcionesSiNo" label="Plan modificado" outlined
                        dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select v-model="filtroReincorporado" :items="opcionesSiNo" label="Reincorporado" outlined
                        dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="saldoMin" label="Saldo mín" type="number" outlined dense
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="saldoMax" label="Saldo máx" type="number" outlined dense
                        hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>

        <!-- Tabla de Datos -->
        <v-card elevation="3">
          <v-card-title class="primary white--text">
            <v-icon color="white" left>mdi-table</v-icon>
            Asignaciones de Cobranza
            <v-spacer></v-spacer>
            <v-chip color="white" outlined>
              {{ datosFiltrados.length }} de {{ cobranzas.length }} registros
            </v-chip>
          </v-card-title>
          <v-data-table id="tabla-cobranzas" :headers="headers" :items="datosFiltrados" :loading="loading"
            :items-per-page="-1" class="elevation-0"
            :items-per-page-options="[5, 10, 25, { text: 'Todos', value: -1 }]">
            <!-- Estado de Asignación -->
            <template v-slot:item.estado_asignacion="{ item }">
              <v-chip :color="getColorEstado(item.estado_asignacion)" dark small>
                {{ item.estado_asignacion }}
              </v-chip>
            </template>

            <!-- Estudiante -->
            <template v-slot:item.estudiante="{ item }">
              <div>
                <div class="font-weight-bold">{{ item.nombres }} {{ item.apellidos }}</div>
                <div class="caption grey--text">{{ item.num_doc }}</div>
                <div class="caption">
                  <v-icon x-small>mdi-email</v-icon>
                  {{ item.correo }}
                </div>
                <div class="caption">
                  <v-icon x-small>mdi-phone</v-icon>
                  {{ item.telefono }}
                </div>
                <div class="caption">
                  <v-icon x-small>mdi-school</v-icon>
                  {{ item.codigo }} - {{ item.nombre_compuesto }}
                </div>
              </div>
            </template>

            <!-- Programa -->
            <!-- <template v-slot:item.programa="{ item }">
              <div>
                <div class="font-weight-medium">{{ item.codigo }}</div>
                <div class="caption">{{ item.categoria }} - {{ item.area }}</div>
                <v-chip x-small :color="item.modalidad === 'Virtual' ? 'blue' : 'green'" dark class="mt-1">
                  {{ item.modalidad }}
                </v-chip>
              </div>
            </template> -->
            <!-- Plan y Concepto -->
            <template v-slot:item.asignacion="{ item }">
              <div>
                <v-chip small :color="item.asignacion === 'Cartera Activa' ? 'deep-orange' : 'green'" dark>
                  <v-icon left>
                    {{ item.asignacion === 'Cartera Activa' ? 'mdi-wallet' : 'mdi-account-check' }}
                  </v-icon>
                  {{ item.asignacion }}
                </v-chip>
              </div>
            </template>

            <!-- Plan y Concepto -->
            <template v-slot:item.plan="{ item }">
              <div>
                <v-chip small :color="item.tipo_plan === 'CREDITO' ? 'orange' : 'blue'" dark>
                  {{ item.tipo_plan }}
                </v-chip>
                <div class="caption mt-1">{{ item.concepto }} #{{ item.nro_cuota }}</div>
              </div>
            </template>

            <!-- Fecha Modificado -->
            <template v-slot:item.plan_modificado="{ item }">
              <div>
                <v-chip small :color="item.plan_modificado ? 'primary' : 'error'" dark>
                  <v-icon>
                    {{ item.plan_modificado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>

                </v-chip>
              </div>

            </template>

            <template v-slot:item.fecha_actual="{ item }">
              <div>
                <div class="caption">
                  <v-icon x-small>mdi-calendar-clock</v-icon>
                  {{ formatFecha(item.fecha_actual) }}
                </div>
              </div>
            </template>

            <!-- Fecha Reincorporado -->
            <template v-slot:item.es_reincorporado="{ item }">
              <div>
                <v-chip small :color="item.es_reincorporado ? 'primary' : 'error'" dark>
                  <v-icon>
                    {{ item.es_reincorporado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>

                </v-chip>
              </div>
            </template>
            <template v-slot:item.fecha_respuesta_solicitud="{ item }">
              <div>
                <div class="caption">
                  <v-icon x-small>mdi-calendar-clock</v-icon>
                  {{ formatFecha(item.fecha_respuesta_solicitud) }}
                </div>
              </div>
            </template>

            <!-- Asignacion -->
            <template v-slot:item.saldo_fecha="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.saldo_fecha) }}</strong>
              </div>
            </template>
            <!-- Disminuciones -->
            <template v-slot:item.total_descuento_fecha_consulta="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_descuento_fecha_consulta) }}</strong>
              </div>
            </template>

            <!-- Pagado -->
            <template v-slot:item.total_pagado_fecha_consulta="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.total_pagado_fecha_consulta) }}</strong>
              </div>
            </template>

            <!-- Saldo -->
            <template v-slot:item.saldo="{ item }">
              <div class="text-right">
                <strong>{{ formatMonto(item.saldo_inicio - item.total_pagado_fecha_consulta -
                  item.total_descuento_fecha_consulta) }}</strong>
              </div>
            </template>





            <!-- Fechas -->
            <template v-slot:item.fechas="{ item }">
              <div>
                <div class="caption">
                  <v-icon x-small>mdi-calendar-clock</v-icon>
                  Límite: {{ formatFecha(item.fecha_limite_pago) }}
                </div>
                <!-- <div class="caption">
                  <v-icon x-small>mdi-calendar-start</v-icon>
                  Inicio: {{ formatFecha(item.fecha_inicio) }}
                </div>
                <div class="caption">
                  <v-icon x-small>mdi-calendar-end</v-icon>
                  Fin: {{ formatFecha(item.fecha_fin) }}
                </div> -->
                <v-chip v-if="calcularDiasRetraso(item.fecha_limite_pago) > 0" small color="red" dark class="mt-1">
                  {{ calcularDiasRetraso(item.fecha_limite_pago) }} días
                </v-chip>
              </div>
            </template>

            <!-- Asesor -->
            <template v-slot:item.asesor="{ item }">
              <div v-if="item.asesor">
                <v-avatar size="32" color="primary" class="mb-1">
                  <span class="white--text text-caption">{{ getIniciales(item.asesor) }}</span>
                </v-avatar>
                <div class="caption">{{ item.asesor }}</div>
              </div>
              <div v-else class="grey--text">Sin asesor</div>
            </template>

            <!-- Encargado de Cobranza -->
            <template v-slot:item.cobrador="{ item }">
              <div v-if="item.encargado_cobranza">
                <v-avatar size="32" color="deep-purple" class="mb-1">
                  <span class="white--text text-caption">{{ getIniciales(item.encargado_cobranza) }}</span>
                </v-avatar>
                <div class="caption">{{ item.encargado_cobranza }}</div>
              </div>
              <div v-else class="grey--text">Sin asignar</div>
            </template>

            <!-- Acciones -->
            <!-- <template v-slot:item.acciones="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="verDetalle(item)">
                    <v-list-item-icon>
                      <v-icon small>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ver Detalle</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="registrarPago(item)">
                    <v-list-item-icon>
                      <v-icon small color="green">mdi-cash-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Registrar Pago</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="enviarRecordatorio(item)">
                    <v-list-item-icon>
                      <v-icon small color="orange">mdi-email-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Enviar Recordatorio</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="verHistorial(item)">
                    <v-list-item-icon>
                      <v-icon small color="blue">mdi-history</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ver Historial</v-list-item-title>
                  </v-list-item>

                  
                </v-list>
              </v-menu>
            </template> -->

            <!-- Totales Generales -->
            <template v-slot:body.append>
              <tr class="font-weight-bold">
                <td colspan="4" class="text-right pr-4">
                  Totales generales:
                </td>
                <td class="text-right success--text">
                  Asignación Total: {{ formatMonto(totalAsignacion) }}
                </td>
                <td class="text-right orange--text">
                  Disminuciones Total: {{ formatMonto(totalDescuentos) }}
                </td>
                <td class="text-right info--text">
                  Pagado Total: {{ formatMonto(totalPagado) }}
                </td>
                <td class="text-right error--text">
                  Saldo Total: {{ formatMonto(totalSaldo) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>

        <!-- Dialog de Detalle -->
        <v-dialog v-model="dialogDetalle" max-width="800">
          <v-card v-if="itemSeleccionado">
            <v-card-title class="primary white--text">
              <v-icon color="white" left>mdi-account-details</v-icon>
              Detalle de Cobranza
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dialogDetalle = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-row>
                <v-col cols="12" md="6">
                  <h3 class="mb-3">Información del Estudiante</h3>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Nombre Completo</v-list-item-subtitle>
                        <v-list-item-title>{{ itemSeleccionado.nombres }} {{ itemSeleccionado.apellidos
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Documento</v-list-item-subtitle>
                        <v-list-item-title>{{ itemSeleccionado.num_doc }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Email</v-list-item-subtitle>
                        <v-list-item-title>{{ itemSeleccionado.correo }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
                        <v-list-item-title>{{ itemSeleccionado.telefono }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Profesión</v-list-item-subtitle>
                        <v-list-item-title>{{ itemSeleccionado.profesion }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="6">
                  <h3 class="mb-3">Información del Pago</h3>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Estado</v-list-item-subtitle>
                        <v-chip :color="getColorEstado(itemSeleccionado.estado_asignacion)" small dark>
                          {{ itemSeleccionado.estado_asignacion }}
                        </v-chip>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Monto Original</v-list-item-subtitle>
                        <v-list-item-title class="text-h6">Bs. {{ formatMonto(itemSeleccionado.monto)
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Descuento</v-list-item-subtitle>
                        <v-list-item-title>Bs. {{ formatMonto(itemSeleccionado.descuento_fecha) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Pagado</v-list-item-subtitle>
                        <v-list-item-title class="success--text">Bs. {{ formatMonto(itemSeleccionado.pagado_fecha)
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Saldo Pendiente</v-list-item-subtitle>
                        <v-list-item-title class="error--text text-h6">Bs. {{
                          formatMonto(itemSeleccionado.saldo_fecha)
                          }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" text @click="dialogDetalle = false">Cerrar</v-btn>
              <v-btn color="primary" @click="registrarPago(itemSeleccionado)">
                <v-icon left>mdi-cash-plus</v-icon>
                Registrar Pago
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>

    </v-main>

    <!-- Snackbar para notificaciones -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import * as XLSX from 'xlsx';
import asignacionFormatos from '@/mixins/asignacionFormatos';

export default {
  name: 'SistemaCobranza',
  mixins: [asignacionFormatos],
  data() {
    return {
      exportando: false,
      searchActive: false,
      buscarPrograma: '',
      menuFechaInicio: false,
      dateInicio: new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1) - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      tab: null,
      islinktoviewdirectasig: false,
      gestiones: Array.from({ length: 9 }, (_, i) => new Date().getFullYear() - i),
      meses: [
        { id: 1, text: 'Enero' },
        { id: 2, text: 'Febrero' },
        { id: 3, text: 'Marzo' },
        { id: 4, text: 'Abril' },
        { id: 5, text: 'Mayo' },
        { id: 6, text: 'Junio' },
        { id: 7, text: 'Julio' },
        { id: 8, text: 'Agosto' },
        { id: 9, text: 'Septiembre' },
        { id: 10, text: 'Octubre' },
        { id: 11, text: 'Noviembre' },
        { id: 12, text: 'Diciembre' },
      ],
      tiposasignacion: [
        { id: 1, text: 'Asignacion' },
        { id: 2, text: 'Inscritos' },
      ],
      programas: [],
      plataformas: [],
      loadinggestion: false,
      loadingprograms: false,
      loadingmes: false,
      filtros: {
        gestion: null,
        gestionasig: null,
        programa: null,
        mes: null,
        tipoasignacion: null,
      },
      buscar: '',
      datos: [],
      loading: false,
      msg: '',
      omit_filtro: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu2: false,
      xcuota: 1,
      only_cuota: true,
      //loading: false,
      busqueda: '',
      filtroEstado: 'todos',
      filtroTipoPlan: 'todos',
      filtroAsignacion: 'todos',
      filtroConceptos: [],
      filtroModalidad: 'todos',
      filtroCategoria: 'todos',
      filtroArea: 'todos',
      filtroPlanModificado: 'todos',
      filtroReincorporado: 'todos',
      saldoMin: '',
      saldoMax: '',
      panelFiltrosAvanzados: [],

      chipSeleccionado: 0,
      mostrarGraficos: false,
      dialogDetalle: false,
      itemSeleccionado: null,
      opcionesEstado: [
        { text: 'Todos', value: 'todos' },
        { text: 'Vigente', value: 'vigente' },
        { text: 'Retrasado', value: 'retrasado' },
        { text: 'Por Recuperar', value: 'por recuperar' }
      ],

      // opcionesTipoPlan: [
      //   { text: 'Todos', value: 'todos' },
      //   { text: 'Crédito', value: 'CREDITO' },
      //   { text: 'Contado', value: 'CONTADO' }
      // ],
      opcinesAsignaciones: [
        { text: 'Todas', value: 'todos' },
        { text: 'Nuevos Incritos', value: 'Nuevos Inscritos' },
        { text: 'Cartera Activa', value: 'Cartera Activa' }
      ],
      conceptos: [],
      headersPrograma: [
        { text: 'Código', value: 'codigo', sortable: true },
        // { text: 'Gestion', value: 'gestion', sortable: true },
        { text: 'Nombre del Programa', value: 'nombre_compuesto', sortable: true, width: '40%' },
        { text: 'Estudiantes', value: 'total_estudiantes', sortable: true, align: 'center' },
        { text: 'Registros', value: 'total_registros', sortable: true, align: 'center' },
        { text: 'Total C. Plan', value: 'total_fechas_cambiadas', sortable: true, align: 'center' },
        { text: 'Asignacion', value: 'total_saldo_fecha', width: '80px' },
        { text: 'Asignacion Cobranza', value: 'total_saldo_cobranza', width: '80px' },
        { text: 'Asignacion Marketing', value: 'total_saldo_marketing', width: '80px' },
        { text: 'Reincorporados', value: 'total_monto_reincorporados', width: '80px' },
        { text: 'Reincorporados Cobranza', value: 'total_monto_reincorporados_cobranza', width: '80px' },
        { text: 'Reincorporados Marketing', value: 'total_monto_reincorporados_marketing', width: '80px' },
        { text: 'Disminuciones', value: 'total_descuento_fecha_consulta', width: '80px' },
        { text: 'Disminuciones Cobranza', value: 'total_descuento_cobranza', width: '80px' },
        { text: 'Disminuciones Mkt', value: 'total_descuento_marketing', width: '80px' },
        { text: 'Cambios Fechas', value: 'total_monto_fechas_cambiadas', width: '80px' },
        { text: 'Cambios Fechas Cobranza', value: 'total_monto_fechas_cambiadas_cobranza', width: '80px' },
        { text: 'Cambios Fechas Mkt', value: 'total_monto_fechas_cambiadas_marketing', width: '80px' },
        { text: 'Pagado', value: 'total_pagado_fecha_consulta', width: '80px' },
        { text: 'Pagado Cobranza', value: 'total_pagado_cobranza', width: '80px' },
        { text: 'Pagado Mkt', value: 'total_pagado_marketing', width: '80px' },
        { text: 'Saldo', value: 'saldo', width: '80px', sortable: false },
        { text: 'Saldo Cobranza', value: 'saldo_cobranza', width: '80px' },
        { text: 'Saldo Mkt', value: 'saldo_marketing', width: '80px' },
        { text: '', value: 'data-table-expand' }, // Columna para el ícono de expansión
      ],

      // headers: [
      //   { text: 'Estado', value: 'estado_asignacion', width: '120px' },
      //   { text: 'Estudiante', value: 'estudiante', width: '250px', sortable: false },
      //   { text: 'Asignacion', value: 'asignacion', width: '250px', sortable: false },
      //   { text: 'Programa', value: 'programa', width: '200px' },
      //   { text: 'Plan', value: 'plan', width: '150px' },
      //   { text: 'Montos', value: 'montos', width: '180px', sortable: false },
      //   { text: 'Fechas', value: 'fechas', width: '180px', sortable: false },
      //   { text: 'Asesor', value: 'asesor', width: '150px' },
      //   { text: 'Acciones', value: 'acciones', width: '100px', sortable: false, align: 'center' }
      // ],
      headers: [
        { text: 'Estado', value: 'estado_asignacion', width: '120px' },
        { text: 'Estudiante', value: 'estudiante', width: '250px', sortable: false },
        { text: 'Tipo Asignacion', value: 'asignacion', width: '100px', sortable: false },
        // { text: 'Programa', value: 'programa', width: '200px' },
        { text: 'Plan', value: 'plan', width: '150px' },
        { text: 'Modificado', value: 'plan_modificado', width: '30px' },
        { text: 'Fecha Actual', value: 'fecha_actual', width: '30px' },
        { text: 'Reincorporado', value: 'es_reincorporado', width: '30px' },
        { text: 'Fecha Reincorporado', value: 'fecha_respuesta_solicitud', width: '30px' },
        { text: 'Asignacion', value: 'saldo_fecha', width: '80px' },
        { text: 'Disminuciones', value: 'total_descuento_fecha_consulta', width: '80px' },
        { text: 'Pagado', value: 'total_pagado_fecha_consulta', width: '80px' },
        { text: 'Saldo', value: 'saldo', width: '80px', sortable: false },
        // { text: 'Montos', value: 'montos', width: '180px', sortable: false },
        { text: 'Fechas', value: 'fechas', width: '180px', sortable: false },
        { text: 'Asesor', value: 'asesor', width: '150px' },
        { text: 'Cobrador', value: 'cobrador', width: '150px' },
        // { text: 'Acciones', value: 'acciones', width: '100px', sortable: false, align: 'center' }
      ],

      headersDesempenoCobrador: [
        { text: 'Cobrador', value: 'cobrador', sortable: true },
        { text: 'Estudiantes', value: 'total_estudiantes', align: 'center' },
        { text: 'Registros', value: 'total_registros', align: 'center' },
        { text: 'Asignado', value: 'asignado', align: 'end' },
        { text: 'Pagado', value: 'pagado', align: 'end' },
        { text: 'Descuento', value: 'descuento', align: 'end' },
        { text: 'Cambios sin pago', value: 'cambios_sin_pago', align: 'end' },
        { text: 'Saldo pendiente', value: 'saldo_pendiente', align: 'end' },
        { text: '% Pagado', value: 'porc_pagado', align: 'end' },
        { text: '% Recuperado', value: 'porc_recuperado', align: 'end' },
      ],

      cobranzas: [],
      cobranzasSede: [],
      programaSeleccionado: null,
    }
  },

  computed: {

    tituloEstadisticasProgramas() {
      if (this.programaSeleccionado) {
        return `Estadísticas de Cobranza - Programa: ${this.programaSeleccionado.nombre_compuesto} (${this.programaSeleccionado.codigo})`;
      } else {
        return 'Estadísticas de Cobranza - Todos los Programas';
      }
    },

    totalAsignacion() {
      return this.datosFiltrados.reduce((acc, i) => acc + (i.saldo_inicio || 0), 0);
    },
    totalDescuentos() {
      return this.datosFiltrados.reduce((acc, i) => acc + (i.total_descuento_fecha_consulta || 0), 0);
    },
    totalPagado() {
      return this.datosFiltrados.reduce((acc, i) => acc + (i.total_pagado_fecha_consulta || 0), 0);
    },
    totalSaldo() {
      return this.datosFiltrados.reduce(
        (acc, i) =>
          acc +
          ((i.saldo_inicio || 0) -
            (i.total_pagado_fecha_consulta || 0) -
            (i.total_descuento_fecha_consulta || 0)),
        0
      );
    },

    // datosConceptos(){
    //   const conceptosSet = new Set();
    //   this.cobranzas.forEach(item => {
    //     if (item.concepto) {
    //       conceptosSet.add(item.concepto);
    //     }
    //   });
    //   return Array.from(conceptosSet).sort();
    // },
    opcionesTipoPlan() {
      const tiposMap = new Map();
      tiposMap.set('todos', 'Todos');
      this.cobranzas.forEach(item => {
        if (item.tipo_plan) {
          tiposMap.set(item.tipo_plan, item.tipo_plan);
        }
      });
      return Array.from(tiposMap, ([value, text]) => ({ text, value })).sort((a, b) => a.text.localeCompare(b.text));

    },
    opcionesModalidad() {
      return this._opcionesUnicas('modalidad');
    },
    opcionesCategoria() {
      return this._opcionesUnicas('categoria');
    },
    opcionesArea() {
      return this._opcionesUnicas('area');
    },
    opcionesSiNo() {
      return [
        { text: 'Todos', value: 'todos' },
        { text: 'Sí', value: 'si' },
        { text: 'No', value: 'no' },
      ];
    },
    // : [
    //     { text: 'Todos', value: 'todos' },
    //     { text: 'Crédito', value: 'CREDITO' },
    //     { text: 'Contado', value: 'CONTADO' }
    //   ],

    datosConceptos() {
      const conceptosMap = new Map();

      this.cobranzas.forEach(item => {
        if (item.concepto_pago_id && item.concepto) {
          conceptosMap.set(item.concepto_pago_id, item.concepto);
        }
      });

      // Convertimos a array de objetos ordenados por concepto
      return Array.from(conceptosMap, ([id, concepto]) => ({
        concepto_id: id,
        concepto
      })).sort((a, b) => a.concepto.localeCompare(b.concepto));
    },


    datosAgrupadosPorPrograma() {
      // Crear un objeto para agrupar por idprograma
      const agrupados = {};

      this.cobranzasSede.forEach(item => {
        const key = item.idprograma;

        if (!agrupados[key]) {
          // Inicializar el grupo si no existe
          agrupados[key] = {
            idprograma: item.idprograma,
            codigo: item.codigo,
            nombre_compuesto: item.nombre_compuesto,
            modalidad: item.modalidad,
            categoria: item.categoria,
            area: item.area,
            fecha_inicio: item.fecha_inicio,
            fecha_fin: item.fecha_fin,
            // Contadores
            total_registros: 0,
            total_vigentes: 0,
            total_retrasados: 0,
            total_por_recuperar: 0,
            // Totales monetarios
            total_monto: 0,
            total_descuento_inicio: 0,
            total_pagado_inicio: 0,
            total_saldo_inicio: 0,
            total_descuento_fecha: 0,
            total_pagado_fecha: 0,
            total_saldo_fecha: 0,
            total_pagado_fecha_consulta: 0,
            total_descuento_fecha_consulta: 0,
            total_saldo_marketing: 0,
            total_saldo_cobranza: 0,
            total_descuento_marketing: 0,
            total_descuento_cobranza: 0,
            total_pagado_marketing: 0,
            total_pagado_cobranza: 0,

            // Totales por cambios de fechas
            total_monto_fechas_cambiadas: 0,
            total_monto_fechas_cambiadas_marketing: 0,
            total_monto_fechas_cambiadas_cobranza: 0,
            total_fechas_cambiadas: 0,

            // Totales por reincorporados
            total_monto_reincorporados: 0,
            total_monto_reincorporados_marketing: 0,
            total_monto_reincorporados_cobranza: 0,
            total_reincorporados: 0,



            // Estudiantes únicos
            estudiantes: new Set(),
            // Detalle de registros
            registros: []
          };
        }

        // Incrementar contadores
        agrupados[key].total_registros++;


        // Contar por estado
        if (item.estado_asignacion === 'vigente') {
          agrupados[key].total_vigentes++;
        } else if (item.estado_asignacion === 'retrasado') {
          agrupados[key].total_retrasados++;
        } else if (item.estado_asignacion === 'por recuperar') {

          agrupados[key].total_por_recuperar++;
        }
        if (item.es_reincorporado === 1) {
          agrupados[key].total_reincorporados++;
          if (Number(item.total_pagado_fecha_consulta) > 0) {
            agrupados[key].total_monto_reincorporados += parseFloat(item.total_pagado_fecha_consulta) || 0;
          }
          if (item.asignacion === 'Cartera Activa' && Number(item.total_pagado_fecha_consulta) > 0) {
            agrupados[key].total_monto_reincorporados_cobranza += parseFloat(item.total_pagado_fecha_consulta) || 0;
          }
          if (item.asignacion === 'Nuevos Inscritos' && Number(item.total_pagado_fecha_consulta) > 0) {
            agrupados[key].total_monto_reincorporados_marketing += parseFloat(item.total_pagado_fecha_consulta) || 0;
          }

        }
        

        if (item.plan_modificado === 1) {
          agrupados[key].total_fechas_cambiadas++;


          if (Number(item.total_pagado_fecha_consulta) === 0) {
            agrupados[key].total_monto_fechas_cambiadas += parseFloat(item.monto) || 0;
          }

          if (item.asignacion === 'Cartera Activa' && Number(item.total_pagado_fecha_consulta) === 0) {
            agrupados[key].total_monto_fechas_cambiadas_cobranza += parseFloat(item.monto) || 0;
          }
          if (item.asignacion === 'Nuevos Inscritos' && Number(item.total_pagado_fecha_consulta) === 0) {
            agrupados[key].total_monto_fechas_cambiadas_marketing += parseFloat(item.monto) || 0;
          }
        }

        // Sumar montos
        agrupados[key].total_monto += parseFloat(item.monto) || 0;
        agrupados[key].total_descuento_inicio += parseFloat(item.descuento_inicio) || 0;
        agrupados[key].total_pagado_inicio += parseFloat(item.pagado_inicio) || 0;
        agrupados[key].total_saldo_inicio += parseFloat(item.saldo_inicio) || 0;
        agrupados[key].total_descuento_fecha += parseFloat(item.descuento_fecha) || 0;
        agrupados[key].total_pagado_fecha += parseFloat(item.pagado_fecha) || 0;
        agrupados[key].total_saldo_fecha += parseFloat(item.saldo_fecha) || 0;
        agrupados[key].total_pagado_fecha_consulta += parseFloat(item.total_pagado_fecha_consulta) || 0;
        agrupados[key].total_descuento_fecha_consulta += parseFloat(item.total_descuento_fecha_consulta) || 0;

        // Totales por asignación (Marketing / Cobranza)
        if (item.asignacion === 'Nuevos Inscritos') {
          agrupados[key].total_saldo_marketing += parseFloat(item.saldo_fecha) || 0;
          agrupados[key].total_descuento_marketing += parseFloat(item.total_descuento_fecha_consulta) || 0;
          agrupados[key].total_pagado_marketing += parseFloat(item.total_pagado_fecha_consulta) || 0;
        } else if (item.asignacion === 'Cartera Activa') {
          agrupados[key].total_saldo_cobranza += parseFloat(item.saldo_fecha) || 0;
          agrupados[key].total_descuento_cobranza += parseFloat(item.total_descuento_fecha_consulta) || 0;
          agrupados[key].total_pagado_cobranza += parseFloat(item.total_pagado_fecha_consulta) || 0;
        }


        // Agregar estudiante único
        agrupados[key].estudiantes.add(item.idestudiante);

        // Agregar el registro completo
        agrupados[key].registros.push(item);
      });

      // Convertir el objeto a array y calcular total de estudiantes únicos
      return Object.values(agrupados).map(grupo => ({
        ...grupo,
        total_estudiantes: grupo.estudiantes.size,
        estudiantes: Array.from(grupo.estudiantes) // Convertir Set a Array
      }));
    },

    porcentajeCobroSede() {
      const saldo = this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.saldo_fecha) || 0), 0);
      const pagado = this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.total_pagado_fecha_consulta) || 0), 0);
      const descuento = this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.total_descuento_fecha_consulta) || 0), 0);
      const cambios = this.cobranzasSede
        .filter(c => c.plan_modificado === 1 && Number(c.total_pagado_fecha_consulta) === 0)
        .reduce((sum, c) => sum + (parseFloat(c.monto) || 0), 0);
      const recuperado = pagado + descuento + cambios;
      return {
        saldo,
        pagado,
        descuento,
        cambios,
        recuperado,
        porc_pagado: saldo > 0 ? (pagado / saldo) * 100 : 0,
        porc_recuperado: saldo > 0 ? (recuperado / saldo) * 100 : 0,
      };
    },

    desempenoPorCobrador() {
      const agrupados = {};
      this.cobranzasSede.forEach(item => {
        const id = item.encargado_cobranza_id != null ? item.encargado_cobranza_id : 'sin_asignar';
        const nombre = item.encargado_cobranza || 'Sin asignar';
        const key = `${id}|${nombre}`;
        if (!agrupados[key]) {
          agrupados[key] = {
            cobrador_id: item.encargado_cobranza_id,
            cobrador: nombre,
            total_registros: 0,
            estudiantes: new Set(),
            asignado: 0,
            pagado: 0,
            descuento: 0,
            cambios_sin_pago: 0,
          };
        }
        const g = agrupados[key];
        g.total_registros++;
        if (item.idestudiante != null) g.estudiantes.add(item.idestudiante);
        g.asignado += parseFloat(item.saldo_fecha) || 0;
        g.pagado += parseFloat(item.total_pagado_fecha_consulta) || 0;
        g.descuento += parseFloat(item.total_descuento_fecha_consulta) || 0;
        if (item.plan_modificado === 1 && Number(item.total_pagado_fecha_consulta) === 0) {
          g.cambios_sin_pago += parseFloat(item.monto) || 0;
        }
      });
      return Object.values(agrupados)
        .map(g => {
          const recuperado = g.pagado + g.descuento + g.cambios_sin_pago;
          return {
            cobrador_id: g.cobrador_id,
            cobrador: g.cobrador,
            total_registros: g.total_registros,
            total_estudiantes: g.estudiantes.size,
            asignado: g.asignado,
            pagado: g.pagado,
            descuento: g.descuento,
            cambios_sin_pago: g.cambios_sin_pago,
            saldo_pendiente: g.asignado - recuperado,
            porc_pagado: g.asignado > 0 ? (g.pagado / g.asignado) * 100 : 0,
            porc_recuperado: g.asignado > 0 ? (recuperado / g.asignado) * 100 : 0,
          };
        })
        .sort((a, b) => b.porc_recuperado - a.porc_recuperado);
    },

    // Estadísticas generales actualizadas
    estadisticasGenerales() {
      return {
        total_programas: this.datosAgrupadosPorPrograma.length,
        total_registros: this.cobranzasSede.length,
        total_estudiantes_unicos: new Set(this.cobranzasSede.map(c => c.idestudiante)).size,
        total_vigentes: this.cobranzasSede.filter(c => c.estado_asignacion === 'vigente').length,
        total_retrasados: this.cobranzasSede.filter(c => c.estado_asignacion === 'retrasado').length,
        total_por_recuperar: this.cobranzasSede.filter(c => c.estado_asignacion === 'por recuperar').length,
        total_fechas_cambiadas: this.cobranzasSede.filter(c => c.plan_modificado === 1).length,
        total_reincorporados: this.cobranzasSede.filter(c => c.es_reincorporado === 1).length,
        total_reincorporados_persona: new Set(
          this.cobranzasSede
            .filter(c => c.es_reincorporado === 1 && c.idestudiante != null)
            .map(c => c.idestudiante)
        ).size,

        monto_total: this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.monto) || 0), 0),
        saldo_total: this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.saldo_fecha) || 0), 0),
        pagado_total: this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.pagado_fecha) || 0), 0),
        total_pagado_fecha_consulta: this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.total_pagado_fecha_consulta) || 0), 0),
        total_descuento_fecha_consulta: this.cobranzasSede.reduce((sum, c) => sum + (parseFloat(c.total_descuento_fecha_consulta) || 0), 0),

        total_saldo_marketing: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Nuevos Inscritos' ? sum + Number(c.saldo_fecha) : sum, 0),
        total_saldo_cobranza: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Cartera Activa' ? sum + Number(c.saldo_fecha) : sum, 0),
        total_descuento_marketing: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Nuevos Inscritos' ? sum + Number(c.total_descuento_fecha_consulta) : sum, 0),
        total_descuento_cobranza: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Cartera Activa' ? sum + Number(c.total_descuento_fecha_consulta) : sum, 0),
        total_pagado_marketing: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Nuevos Inscritos' ? sum + Number(c.total_pagado_fecha_consulta) : sum, 0),
        total_pagado_cobranza: this.cobranzasSede.reduce((sum, c) => c.asignacion === 'Cartera Activa' ? sum + Number(c.total_pagado_fecha_consulta) : sum, 0),
        total_monto_fechas_cambiadas: this.cobranzasSede.filter(c => c.plan_modificado === 1 && Number(c.total_pagado_fecha_consulta) === 0).reduce((sum, c) => sum + (Number(c.monto) || 0), 0),
        total_monto_fechas_cambiadas_marketing: this.cobranzasSede.filter(c => c.plan_modificado === 1 && c.asignacion === 'Nuevos Inscritos' && Number(c.total_pagado_fecha_consulta) === 0).reduce((sum, c) => sum + (Number(c.monto) || 0), 0),
        total_monto_fechas_cambiadas_cobranza: this.cobranzasSede.filter(c => c.plan_modificado === 1 && c.asignacion === 'Cartera Activa' && Number(c.total_pagado_fecha_consulta) === 0).reduce((sum, c) => sum + (Number(c.monto) || 0), 0),
        total_monto_reincorporados: this.cobranzasSede.filter(c => c.es_reincorporado === 1 && Number(c.total_pagado_fecha_consulta) > 0).reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0),
        total_monto_reincorporados_marketing: this.cobranzasSede.filter(c => c.es_reincorporado === 1 && c.asignacion === 'Nuevos Inscritos' && Number(c.total_pagado_fecha_consulta) > 0).reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0),
        total_monto_reincorporados_cobranza: this.cobranzasSede.filter(c => c.es_reincorporado === 1 && c.asignacion === 'Cartera Activa' && Number(c.total_pagado_fecha_consulta) > 0).reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0),

      };
    },
    datosFiltrados() {
      let datos = this.cobranzas;

      // Filtro por estado
      if (this.filtroEstado !== 'todos') {
        datos = datos.filter(item => item.estado_asignacion === this.filtroEstado);
      }

      // Filtro por tipo de plan
      if (this.filtroTipoPlan !== 'todos') {
        datos = datos.filter(item => item.tipo_plan === this.filtroTipoPlan);
      }

      if (this.filtroAsignacion !== 'todos') {
        datos = datos.filter(item => item.asignacion === this.filtroAsignacion);
      }
      if (this.busqueda) {
        const busquedaLower = this.busqueda.toLowerCase();
        datos = datos.filter(item => {
          const nombres = item.nombres ? item.nombres.toLowerCase() : '';
          const apellidos = item.apellidos ? item.apellidos.toLowerCase() : '';
          const num_doc = item.num_doc ? item.num_doc.toLowerCase() : '';
          const correo = item.correo ? item.correo.toLowerCase() : '';
          const telefono = item.telefono ? item.telefono.toString() : '';

          return nombres.includes(busquedaLower) ||
            apellidos.includes(busquedaLower) ||
            num_doc.includes(busquedaLower) ||
            correo.includes(busquedaLower) ||
            telefono.includes(busquedaLower);
        });
      }

      // Filtro por chip seleccionado
      if (this.chipSeleccionado === 1) {
        datos = datos.filter(item => item.estado_asignacion === 'vigente');
      } else if (this.chipSeleccionado === 2) {
        datos = datos.filter(item => item.estado_asignacion === 'retrasado');
      } else if (this.chipSeleccionado === 3) {
        datos = datos.filter(item => item.estado_asignacion === 'por recuperar');
      }

      // Filtro por conceptos múltiples
      if (this.filtroConceptos && this.filtroConceptos.length > 0) {
        datos = datos.filter(item =>
          this.filtroConceptos.includes(item.concepto_pago_id)
        );
      }

      // Filtros avanzados
      if (this.filtroModalidad !== 'todos') {
        datos = datos.filter(item => item.modalidad === this.filtroModalidad);
      }
      if (this.filtroCategoria !== 'todos') {
        datos = datos.filter(item => item.categoria === this.filtroCategoria);
      }
      if (this.filtroArea !== 'todos') {
        datos = datos.filter(item => item.area === this.filtroArea);
      }
      if (this.filtroPlanModificado !== 'todos') {
        const esperado = this.filtroPlanModificado === 'si' ? 1 : 0;
        datos = datos.filter(item => Number(item.plan_modificado) === esperado);
      }
      if (this.filtroReincorporado !== 'todos') {
        const esperado = this.filtroReincorporado === 'si' ? 1 : 0;
        datos = datos.filter(item => Number(item.es_reincorporado) === esperado);
      }
      const min = parseFloat(this.saldoMin);
      if (!isNaN(min)) {
        datos = datos.filter(item => Number(item.saldo_fecha) >= min);
      }
      const max = parseFloat(this.saldoMax);
      if (!isNaN(max)) {
        datos = datos.filter(item => Number(item.saldo_fecha) <= max);
      }

      return datos;
    },

    estadisticas() {
      const datos = this.datosFiltrados;
      const total = datos.length;

      // Subconjuntos cacheados para evitar recorrer múltiples veces
      const vigentesArr = datos.filter(c => c.estado_asignacion === 'vigente');
      const retrasadosArr = datos.filter(c => c.estado_asignacion === 'retrasado');
      const porRecuperarArr = datos.filter(c => c.estado_asignacion === 'por recuperar');
      const planModificados = datos.filter(c => c.plan_modificado === 1);
      const reincorporadosArr = datos.filter(c => c.es_reincorporado === 1);

      // Acumuladores por asignación en un solo recorrido
      let montoTotal = 0;
      let saldoTotal = 0;
      let pagadoTotal = 0;
      let descuentoTotal = 0;
      let saldoTotalMarketing = 0;
      let saldoTotalCobranza = 0;
      let descuentoTotalMarketing = 0;
      let descuentoTotalCobranza = 0;
      let pagadoTotalMarketing = 0;
      let pagadoTotalCobranza = 0;

      datos.forEach(c => {
        const monto = Number(c.monto) || 0;
        const saldo = Number(c.saldo_fecha) || 0;
        const pagado = Number(c.total_pagado_fecha_consulta) || 0;
        const descuento = Number(c.total_descuento_fecha_consulta) || 0;

        montoTotal += monto;
        saldoTotal += saldo;
        pagadoTotal += pagado;
        descuentoTotal += descuento;

        if (c.asignacion === 'Nuevos Inscritos') {
          saldoTotalMarketing += saldo;
          descuentoTotalMarketing += descuento;
          pagadoTotalMarketing += pagado;
        } else if (c.asignacion === 'Cartera Activa') {
          saldoTotalCobranza += saldo;
          descuentoTotalCobranza += descuento;
          pagadoTotalCobranza += pagado;
        }
      });

      // Cambios de fecha sin pago: derivado de planModificados
      const cambiosSinPago = planModificados.filter(c => Number(c.total_pagado_fecha_consulta) === 0);
      const total_monto_fechas_cambiadas = cambiosSinPago.reduce((sum, c) => sum + (Number(c.monto) || 0), 0);
      const total_monto_fechas_cambiadas_marketing = cambiosSinPago
        .filter(c => c.asignacion === 'Nuevos Inscritos')
        .reduce((sum, c) => sum + (Number(c.monto) || 0), 0);
      const total_monto_fechas_cambiadas_cobranza = cambiosSinPago
        .filter(c => c.asignacion === 'Cartera Activa')
        .reduce((sum, c) => sum + (Number(c.monto) || 0), 0);

      // Reincorporados con pago: derivado de reincorporadosArr
      const reincorporadosConPago = reincorporadosArr.filter(c => Number(c.total_pagado_fecha_consulta) > 0);
      const total_monto_reincorporados = reincorporadosConPago.reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0);
      const total_monto_reincorporados_marketing = reincorporadosConPago
        .filter(c => c.asignacion === 'Nuevos Inscritos')
        .reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0);
      const total_monto_reincorporados_cobranza = reincorporadosConPago
        .filter(c => c.asignacion === 'Cartera Activa')
        .reduce((sum, c) => sum + (Number(c.total_pagado_fecha_consulta) || 0), 0);

      return {
        total,
        vigentes: vigentesArr.length,
        retrasados: retrasadosArr.length,
        porRecuperar: porRecuperarArr.length,
        montoTotal,
        saldoTotal,
        pagadoTotal,
        descuentoTotal,
        saldoTotalMarketing,
        saldoTotalCobranza,
        descuentoTotalMarketing,
        descuentoTotalCobranza,
        pagadoTotalMarketing,
        pagadoTotalCobranza,
        total_fechas_cambiadas: planModificados.length,
        total_monto_fechas_cambiadas,
        total_monto_fechas_cambiadas_marketing,
        total_monto_fechas_cambiadas_cobranza,
        total_monto_reincorporados,
        total_monto_reincorporados_marketing,
        total_monto_reincorporados_cobranza,
        total_reincorporados: reincorporadosArr.length,
      };
    }
  },

  methods: {
    exportarAExcel() {
      if (this.exportando) return; // Prevenir doble clic
      this.exportando = true;

      try {
        // 1. PREPARAR LOS DATOS
        // Es una buena práctica mapear los datos a un formato más limpio
        // con cabeceras amigables para el usuario.
        const datosParaExportar = this.datosAgrupadosPorPrograma.map(item => {
          return {
            'Programa': item.nombre_compuesto,
            'Código Programa': item.codigo,
            'modalidad': item.modalidad,
            'categoria': item.categoria,
            'area': item.area,
            'fecha_inicio': item.fecha_inicio,
            'fecha_fin': item.fecha_fin,
            'Monto Asignado': item.total_saldo_fecha,
            'Monto Asignado Cobranza': item.total_saldo_cobranza,
            'Monto Asignado Mkt': item.total_saldo_marketing,
            'Monto Reincorporados': item.total_monto_reincorporados ?? 0,
            'Monto Reincorporados Cobranza': item.total_monto_reincorporados_cobranza ?? 0,
            'Monto Reincorporados Mkt': item.total_monto_reincorporados_marketing ?? 0,
            'Descuento': item.total_descuento_fecha_consulta ?? 0,
            'Descuento Cobranza': item.total_descuento_cobranza ?? 0,
            'Descuento Mkt': item.total_descuento_marketing ?? 0,
            'Cambios de Fechas': item.total_monto_fechas_cambiadas ?? 0,
            'Cambios de Fechas Cobranza': item.total_monto_fechas_cambiadas_cobranza ?? 0,
            'Cambios de Fechas Mkt': item.total_monto_fechas_cambiadas_marketing ?? 0,
            'Pagado': item.total_pagado_fecha_consulta ?? 0,
            'Pagado Cobranza': item.total_pagado_cobranza ?? 0,
            'Pagado Mkt': item.total_pagado_marketing ?? 0,
            'Saldo':
              (item.total_saldo_fecha ?? 0)
              - (item.total_descuento_fecha_consulta ?? 0)
              - (item.total_monto_fechas_cambiadas ?? 0)
              - (item.total_pagado_fecha_consulta ?? 0),
            'Saldo Cobranza':
              (item.total_saldo_cobranza ?? 0)
              - (item.total_descuento_cobranza ?? 0)
              - (item.total_monto_fechas_cambiadas_cobranza ?? 0)
              - (item.total_pagado_cobranza ?? 0),
            'Saldo Mkt':
              (item.total_saldo_marketing ?? 0)
              - (item.total_descuento_marketing ?? 0)
              - (item.total_monto_fechas_cambiadas_marketing ?? 0)
              - (item.total_pagado_marketing ?? 0),

          };
        });

        // 2. CREAR LA HOJA DE CÁLCULO (Worksheet)
        const worksheet = XLSX.utils.json_to_sheet(datosParaExportar);

        // Opcional: Ajustar el ancho de las columnas
        worksheet['!cols'] = [
          { wch: 15 }, // 'Código'
          { wch: 50 }, // 'Nombre del Programa'          
        ];

        // 3. CREAR EL LIBRO DE TRABAJO (Workbook)
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Asignacion Sede');

        // 4. GENERAR Y DESCARGAR EL ARCHIVO
        const nombreArchivo = `Reporte_Asignacion_Sedes_${this.$store.state.CARGO.sede.nombre} _${new Date().toISOString().slice(0, 10)}.xlsx`;
        XLSX.writeFile(workbook, nombreArchivo);

      } catch (error) {
        window.console.error("Error al exportar a Excel:", error);
        this.mostrarNotificacion('No se pudo exportar a Excel. Intenta nuevamente.', 'error');
      } finally {
        setTimeout(() => {
          this.exportando = false;
        }, 500);
      }
    },
    verDetallePrograma(programa) {
      // Filtrar los datos para mostrar solo los registros de este programa
      this.programaSeleccionado = programa;
      this.cobranzas = programa.registros;
      this.mostrarNotificacion(`Mostrando ${programa.registros.length} registros del programa ${programa.codigo}`, 'info');

      // Hacer scroll hacia la tabla
      // this.$vuetify.goTo('#tabla-cobranzas', {
      //   duration: 500,
      //   offset: 0,
      //   easing: 'easeInOutCubic'
      // });
    },
    validarNoFechaFutura() {
      const hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString().substr(0, 10);
      if (this.date > hoy) {
        this.date = hoy;
        this.mostrarNotificacion('La fecha fin no puede ser futura. Se ajustó a hoy.', 'warning');
      }
    },
    validarRangoFechas() {
      if (this.dateInicio && this.date && this.dateInicio > this.date) {
        this.mostrarNotificacion('La fecha de inicio no puede ser mayor a la fecha fin.', 'error');
        return false;
      }
      return true;
    },
    async cargasDatosV2(sedeId, fechaAsignacion, fechaInicio, fechaFin) {
      if (!this.validarRangoFechas()) return;
      this.loading = true;

      // Implementar llamada API real aquí
      let sede_id = this.$store.state.CARGO.sede.id;
      //let idsede = this.$route.query.idsede;
      // if (idsede) {
      //   sede_id = idsede;
      //   this.xname = this.$route.query.name;
      // }
      sedeId = sede_id;

      if (!fechaAsignacion) {
        fechaAsignacion = this.dateInicio;
      }
      if (!fechaInicio) {
        fechaInicio = `${this.dateInicio} 00:00:00`;
      }
      if (!fechaFin) {
        fechaFin = `${this.date} 23:59:59`;
      }

      try {
        const url = `${process.env.VUE_APP_API_REST}/api/v4/esam/asignacion/programas`;
        let sedeString = String(sedeId);

        // parámetros de la URL
        const params = {
          sede: sedeString,
          fecha_asignacion: fechaAsignacion,
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin,
        };

        const response = await xaxios.get(url, { params });

        this.cobranzas = response.data.data || [];
        this.cobranzasSede = response.data.data || [];

        this.loading = false;
        if (this.cobranzas.length === 0) {
          this.mostrarNotificacion('No se encontraron asignaciones para los criterios seleccionados.', 'info');
        } else {
          this.mostrarNotificacion('Asignaciones cargadas correctamente.', 'success');
        }

      } catch (error) {
        this.loading = false;
        const detalle = error?.response?.data?.message || error?.response?.data?.error || error?.message || '';
        const texto = detalle ? `Error en la consulta: ${detalle}` : 'Error en la consulta';
        this.mostrarNotificacion(texto, 'error');
        window.console.error('Error al obtener asignaciones:', error);
      }

    },
    async listarprogramasgraphql() {
      this.loadingprograms = true;
      this.loadingmodulos = true;
      this.programas = [];
      this.filtros.programa = null;
      let idsede = this.$store.state.CARGO.sede.id;
      const vue = this;
      var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede}, gestion:${this.filtros.gestion}){ id,fase,version,grupo,estado,fecha_inicio,fecha_fin,codigo,nombre_compuesto,universidad{id,nombre},postgrado{categoria{id}},plataforma_id} getPlataformas(estado: true) { id nombre direccion unidad_negocio_id estado } }`;
      await this.$apollo
        .query({ query: sql, variables: { cursor: this.cursor } })
        .then(({ data }) => {
          let datos = data.getProgramas;
          if (this.$store.state.convenio && !this.omit_filtro) {
            datos = datos.filter((x) => {
              let convenio = vue.$store.state.convenio.id;
              if (!x.universidad) x.universidad = { id: convenio };
              let universidad = x.universidad.id;
              return convenio == universidad;
            });
          }

          vue.plataformas = data.getPlataformas;
          datos.forEach((x, indice) => {
            if (!x.codigo) x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
            else x.text = `${indice + 1}.- ${x.nombre_compuesto} [${x.codigo}]`;
            x.value = x.id;
            let iscurso = x.postgrado.categoria.id == 500; // curso id = 5
            if (!iscurso) vue.programas.push(x);
          });
          if (vue.filtros.programa) {
            let existe = vue.programas.find((x) => x.id == vue.filtros.programa.id);
            if (!existe) vue.programas.push(vue.filtros.programa);
          }
          vue.loadingprograms = false;
          vue.loadingmodulos = false;
        })
        .catch(() => {
          vue.loadingprograms = false;
          vue.loadingmodulos = false;
        });
    },

    limpiarFiltros() {
      this.busqueda = '';
      this.filtroEstado = 'todos';
      this.filtroTipoPlan = 'todos';
      this.filtroAsignacion = 'todos';
      this.chipSeleccionado = 0;
      this.filtroConceptos = [];
      this.filtroModalidad = 'todos';
      this.filtroCategoria = 'todos';
      this.filtroArea = 'todos';
      this.filtroPlanModificado = 'todos';
      this.filtroReincorporado = 'todos';
      this.saldoMin = '';
      this.saldoMax = '';
      this.mostrarNotificacion('Filtros limpiados', 'info');
    },

    _opcionesUnicas(campo) {
      const valores = new Set();
      this.cobranzas.forEach(item => {
        if (item[campo]) valores.add(item[campo]);
      });
      const opciones = Array.from(valores)
        .sort((a, b) => String(a).localeCompare(String(b)))
        .map(v => ({ text: v, value: v }));
      return [{ text: 'Todos', value: 'todos' }, ...opciones];
    },

    verDetalle(item) {
      this.itemSeleccionado = item;
      this.dialogDetalle = true;
    },

    registrarPago(item) {
      this.mostrarNotificacion(`Abriendo formulario de pago para ${item.nombres} ${item.apellidos}`, 'info');
      // Aquí iría la lógica para abrir el formulario de registro de pago
    },

    enviarRecordatorio(item) {
      this.mostrarNotificacion(`Enviando recordatorio a ${item.correo}`, 'success');
      // Aquí iría la lógica para enviar el recordatorio
    },

    verHistorial(item) {
      this.mostrarNotificacion(`Mostrando historial de ${item.nombres} ${item.apellidos}`, 'info');
      // Aquí iría la lógica para mostrar el historial
    },

    initCharts() {
      this.$nextTick(() => {
        if (this.$refs.chartEstados && this.$refs.chartMontos) {
          // Placeholder para inicialización de gráficos con Chart.js
        }
      });
    }
  },

  watch: {


    mostrarGraficos(val) {
      if (val) {
        this.initCharts();
      }
    },
    'filtros.gestion': function () {
      // this.resetasignaciones();
      if (this.filtros.gestion) this.listarprogramasgraphql();
    },
    'filtros.tipoasignacion': function () {
      if (this.filtros.tipoasignacion) this.setipoasignacion();
    },
    '$store.state.CARGO.sede': function () {
      // this.resetasignaciones();
      this.listarprogramasgraphql();
    },
    '$store.state.convenio': function () {
      if (this.$store.state.convenio) {
        this.listarprogramasgraphql();
      }
    },
    omit_filtro: function () {
      this.listarprogramasgraphql();
    },
    date: function () {
      this.validarNoFechaFutura();
    },
  }
}
</script>

<style scoped>
.v-data-table {
  font-size: 0.875rem;
}

.caption {
  font-size: 0.75rem !important;
}

.v-chip.v-chip--x-small {
  height: 18px;
  font-size: 0.65rem;
}

.v-card__title {
  word-break: break-word;
}

.transition-ease {
  transition: all 0.3s ease-in-out;
}

.rounded-xl {
  border-radius: 16px !important;
}

/* Pantallas grandes (Desktop): Forzar anchos personalizados */
@media (min-width: 960px) {

  /* Para la fila de 7 elementos: 100% / 7 = 14.28% */
  .cols-custom-7 {
    flex: 0 0 14.28%;
    max-width: 14.28%;
  }

  /* Para la fila de 5 elementos: 100% / 5 = 20% */
  .cols-custom-5 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>